/**
 * VALIDACION PAGE - Validación de Resultados
 */
import { CheckCircle } from "lucide-react";
import { PlaceholderPage } from "../placeholder-page";

export default function ValidacionPage() {
  return (
    <PlaceholderPage
      titleKey="validacion.title"
      descriptionKey="validacion.description"
      icon={CheckCircle}
    />
  );
}
